import { showNotification } from "jazasoft";
import { getDistinctValues, isEmpty } from "./helpers";

const getNestedErrors = error => {
  if (isEmpty(error)) return [];
  if (!isEmpty(error.errors) && Array.isArray(error.errors)) {
    return error.errors.flatMap(e => getNestedErrors(e));
  } else {
    return Array.isArray(error.message) ? error.message : typeof error.message === "string" ? [error.message] : [];
  }
};

const handleError = (error, dispatch) => {
  if (error && typeof error.message === "string") {
    dispatch(showNotification(error.message, { type: "danger", placement: "bc", autoHideDuration: 10000 }));
  } else if (typeof error?.errors === "object" && Array.isArray(error.errors)) {
    const errorList = getNestedErrors(error);
    const message = getDistinctValues(errorList).join("\n\r");
    if (!isEmpty(errorList)) {
      dispatch(showNotification(message, { type: "danger", placement: "bc", autoHideDuration: 10000 }));
    }
  } else {
    console.log(error);
  }
};

export default handleError;
